import type { IEntity, IPoint } from "dxf-parser";
import type { IGroup } from "dxf-parser/dist/DxfArrayScanner";
import type DxfArrayScanner from "dxf-parser/dist/DxfArrayScanner";
import type IGeometry from "dxf-parser/dist/entities/geomtry";
import * as helpers from "lib/house/dxf/import/dxfParserLibHelpers";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IHatchEntity extends IEntity {
  solidFill?: boolean;
  patternName?: string;
  patternAngle?: number;
  patternScale?: number;
  boundaryPaths: IBoundaryPath[];
  extrusionDirection?: IPoint;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IBoundaryPath {
  type: "Polyline" | "Loop";
  vertices: IPoint[];
}

export default class Hatch implements IGeometry {
  public ForEntityName = "HATCH" as any; // this is hacky because the library doesn't expect this

  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = {
      type: curr.value,
      boundaryPaths: [] as IBoundaryPath[],
    } as IHatchEntity;

    curr = scanner.next();
    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break;
      }

      switch (curr.code) {
        case 70: // Solid fill flag (1 = solid fill, 0 = pattern fill)
          entity.solidFill = curr.value === 1;
          break;
        case 2: // Pattern name
          entity.patternName = curr.value as string;
          break;
        case 41: // Pattern angle
          entity.patternAngle = parseFloat(curr.value as string);
          break;
        case 43: // Pattern scale
          entity.patternScale = parseFloat(curr.value as string);
          break;
        case 210: // Extrusion direction (X)
        case 220: // Extrusion direction (Y)
        case 230: // Extrusion direction (Z)
          entity.extrusionDirection = helpers.parsePoint(scanner);
          break;
        case 91: // Number of boundary paths
          const boundaryCount = parseInt(curr.value as string);
          for (let i = 0; i < boundaryCount; i++) {
            entity.boundaryPaths.push(this.parseBoundaryPath(scanner));
          }
          break;
        default:
          // Handle common entity properties
          helpers.checkCommonEntityProperties(entity, curr, scanner);
          break;
      }

      curr = scanner.next();
    }
    return entity;
  }

  // TODO - this is the MOST barebones version of this and will likely not handle any
  // edge cases beyond simple polygons
  private parseBoundaryPath(scanner: DxfArrayScanner): IBoundaryPath {
    const path: IBoundaryPath = { type: "Loop", vertices: [] };
    let curr = scanner.next();
    while (!scanner.isEOF() && curr.code !== 0) {
      // End of path can be marked with 0 or a new entity
      if (curr.code === 97) {
        // Boundary path end code (DXF loop ends here)
        break;
      }

      switch (curr.code) {
        case 72: // Polyline flag
          path.type = "Polyline";
          break;
        case 10: // Vertex X (Polyline)
        case 20: // Vertex Y
        case 30: // Vertex Z
          path.vertices.push(helpers.parsePoint(scanner)); // Only collect vertices
          break;
        default:
          break;
      }
      curr = scanner.next();
    }
    return path;
  }
}
